import React from 'react';	
import PropTypes from 'prop-types';	
import isDefined from '../components/shared/FormBuilder/utils/isDefined';	
import {ControlLabel} from 'react-bootstrap';
import { FormGroup } from 'react-bootstrap';
import classNames from 'classnames';

 export default class CheckBoxes extends React.Component {	
    constructor(props) {	
        super(props);	
        const name = this.props.data.name;	
        const initialValue = this.props.initialValues[name];	
        const selected = isDefined(initialValue) ? initialValue.split(',') : [];	
        const selectedArray = this.props.data.attributes.options.map((option, index) => {	
            if (selected.includes(option.value.toString())) {	
                return (	
                    option.value.toString()	
                )	
            }	
        }).filter(Boolean);	
        this.state = {	
            value: isDefined(initialValue) ? initialValue : [],	
            selectedOptions: isDefined(selectedArray) ? selectedArray : [],
            selectedValueArray: selectedArray,	
            disableSpecifics: selectedArray.length>0 && initialValue === 'false',
            disableNone: selectedArray.length>0 && initialValue !== 'false',
        };	
        this.handleChangeEvent = this.handleChangeEvent.bind(this);	
    }	

     componentWillReceiveProps(nextProps){	
        if(nextProps.hidden){	
            this.setState({value:'',selectedOptions:[]})	
        }	
    }	

     handleChangeEvent(event) {	
         const value = event.target.value.toString();
        let selectedValueArray = this.state.selectedValueArray;
        if(!selectedValueArray.includes(value)) {
            if(value==='false') {
                selectedValueArray = [];
                this.setState({
                    disableSpecifics:true
                })
            }
            else {
                selectedValueArray=selectedValueArray.filter(k=>{
                    if (k !== 'false') return k
                })
                this.setState({
                    disableNone:true
                })
            }
            selectedValueArray.push(value)
            this.setState({
                selectedValueArray
            })
        } else {
            selectedValueArray=this.state.selectedValueArray.filter(key => {
                if (key !== value) return key
            })
            if (selectedValueArray.length === 0) {
                this.setState({
                    disableNone: false,
                    disableSpecifics: false,
                })
            }
        }
        this.setState({
            selectedValueArray,
            value: selectedValueArray.toString()
        })
        this.props.handleFormChange();	
    }	

     render() {
        let Options = this.props.data.attributes.options;
	
        return (	
            <FormGroup controlId={this.props.data.name}>
            <div className="label-container checkboxQuestion">	
                {this.props.data.text && <ControlLabel className={classNames({mandatoryField: this.props.data.required, requiredLabel: (!this.state.value.length && this.props.requiredLabel) })}>{this.props.data.text}</ControlLabel>}	
               	<div className={classNames(this.props.data.name, "row")} style={{minWidth:'120%', marginLeft:'0%'}}>
                {Options && Options.map((opt, index) => {

                    return (                        
                       <label className={classNames('radioText', 'col-xs-4', 'checkboxLabel',
                       {separateSection: opt.value === false}
                       )}>
                        <input
                        type="checkbox" 
                        name={opt.text}
                        id={index} 
                        disabled={opt.value===false ? this.state.disableNone : this.state.disableSpecifics} 
                        className={classNames('showForms', 'checkboxInput'
                        )}
                        defaultChecked={this.state.selectedValueArray.includes(opt.value.toString())} 
                        onClick={this.handleChangeEvent} value={opt.value}/>
                       {opt.text}</label>
                        
                    );	
                })}	
                </div>
                {this.props.data.helper && <div className="helper">{this.props.data.helper}</div>}	
            </div>
            </FormGroup>
            	
        )	
    }	
}	
CheckBoxes.propTypes = {	
    handleFormChange: PropTypes.func,	
    initialValues: PropTypes.object,	
}; 